import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { renderComponentToElement } from '.';
import { DragIcon } from './DragIcon';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

const dragIconsMap = {
  [ETreeNodeTypes.Protein]: 'AddProtein',
  [ETreeNodeTypes.Screen]: 'AddScreen',
  [ETreeNodeTypes.Seed]: 'Seed',
  [ETreeNodeTypes.FragmentScreen]: 'FragmentScreen',
};

export const getDragImage = (customIcons, selectedFiles) => {
  if (customIcons) {
    const type = dragIconsMap[selectedFiles[0].type];
    const name = selectedFiles[0].name;
    return renderComponentToElement(
      RMSvgIcon,
      { name: type, height: '2rem', width: '2rem' },
      name,
    );
  }
  return renderComponentToElement(DragIcon, { number: selectedFiles.length });
};
